import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDateTime } from "@/lib/format";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Skeleton } from "@/components/ui/skeleton";
import { StickyNote, Send } from "lucide-react";
import { toast } from "sonner";

export default function PartnerNotes() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [body, setBody] = useState("");
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try { const { data } = await api.get("/portal/partner/notes"); setItems(data.items || []); }
    finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!body.trim()) return;
    setSaving(true);
    try { await api.post("/portal/partner/notes", { body }); setBody(""); await load(); toast.success("Note added"); }
    catch { toast.error("Could not add note"); }
    finally { setSaving(false); }
  };

  return (
    <div>
      <h2 className="font-display text-2xl font-bold text-[#252221] mb-1">Notes</h2>
      <p className="text-sm text-muted-foreground mb-5">Add updates the MovingMyMama team can see.</p>
      <Card className="p-4 border-[#E6EDF2] mb-4" style={{ boxShadow: "var(--mmm-shadow-sm)" }}>
        <Textarea value={body} onChange={(e) => setBody(e.target.value)} rows={3} placeholder="Share an update on a referral or task..." data-testid="partner-note-input" className="resize-none mb-2" />
        <div className="flex justify-end">
          <Button onClick={add} disabled={saving || !body.trim()} className="text-white" style={{ backgroundColor: "var(--mmm-red)" }} data-testid="partner-note-submit"><Send size={15} className="mr-2" /> Add note</Button>
        </div>
      </Card>
      {loading ? <div className="space-y-3">{[...Array(2)].map((_, i) => <Skeleton key={i} className="h-16" />)}</div> :
        items.length === 0 ? <Card className="p-10 text-center text-muted-foreground border-[#E6EDF2]" data-testid="partner-notes-empty">No notes yet.</Card> : (
          <div className="space-y-3">
            {items.map((n) => (
              <Card key={n.id} className="p-4 border-[#E6EDF2]" style={{ boxShadow: "var(--mmm-shadow-sm)" }} data-testid="partner-note-card">
                <div className="flex items-start gap-2.5">
                  <StickyNote size={16} className="text-[#1C4358] mt-0.5 shrink-0" />
                  <div className="min-w-0">
                    <div className="text-sm text-[#252221] whitespace-pre-wrap leading-relaxed">{n.body}</div>
                    <div className="text-[11px] text-muted-foreground mt-1">{n.author_name} · {formatDateTime(n.created_at)}</div>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        )}
    </div>
  );
}
